var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4, _rect5, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileFuture1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 111,
    viewBox: "0 0 312 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 52.6678,
    height: 51.9037,
    rx: 16.5,
    transform: "matrix(-1 0 0 1 311.668 8.67041)",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_3264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.291 46.1124C291.667 46.1124 294.404 43.3755 294.404 39.9994C294.404 36.6233 291.667 33.8865 288.291 33.8865C284.915 33.8865 282.178 36.6233 282.178 39.9994C282.178 43.3755 284.915 46.1124 288.291 46.1124Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.131 34.0901C293.964 33.0107 294.412 31.6839 294.404 30.3205C294.386 28.5698 293.682 26.8962 292.444 25.6582C291.206 24.4203 289.532 23.7166 287.782 23.6981C286.792 23.6929 285.816 23.9208 284.931 24.3633C284.046 24.8058 283.277 25.4505 282.688 26.2452C282.098 25.4505 281.33 24.8058 280.445 24.3633C279.56 23.9208 278.583 23.6929 277.594 23.6981C275.843 23.7166 274.169 24.4203 272.931 25.6582C271.693 26.8962 270.99 28.5698 270.971 30.3205C270.972 31.1816 271.151 32.0332 271.497 32.8221C271.842 33.611 272.346 34.3201 272.978 34.9052C273.997 35.9597 280.288 42.5464 282.148 44.528",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.348 37.9822L287.272 42.0167L285.235 39.9791",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 129.5,
    y: 2.17041,
    width: 52.6678,
    height: 51.9037,
    rx: 16.5,
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_468_3264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.461 28.3259C168.65 28.3259 167.873 28.0039 167.299 27.4307C166.726 26.8575 166.404 26.0801 166.404 25.2694V20.481",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.556 36.2729V17.4246C147.556 17.1544 147.663 16.8952 147.854 16.7042C148.045 16.5131 148.305 16.4058 148.575 16.4058H160.291C160.561 16.4058 160.821 16.5131 161.012 16.7042C161.203 16.8952 161.31 17.1544 161.31 17.4246V36.2729",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.763 18.9526H150.103V26.0844H158.763V18.9526Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.838 37.2915L161.31 36.2727H147.556L146.028 37.2915V39.8386H162.838V37.2915Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31 32.4215V31.1785C161.299 30.9081 161.345 30.6383 161.443 30.3862C161.542 30.1341 161.692 29.9052 161.883 29.7138C162.074 29.5224 162.303 29.3726 162.555 29.274C162.807 29.1755 163.077 29.1301 163.348 29.1409C163.888 29.1409 164.406 29.3556 164.789 29.7377C165.171 30.1198 165.385 30.6381 165.385 31.1785V32.7068C165.385 33.2472 165.6 33.7655 165.982 34.1476C166.364 34.5297 166.883 34.7444 167.423 34.7444C167.694 34.7552 167.963 34.7098 168.215 34.6112C168.467 34.5126 168.696 34.3629 168.888 34.1715C169.079 33.9801 169.229 33.7512 169.328 33.4991C169.426 33.247 169.471 32.9772 169.461 32.7068V26.0844C169.461 22.0091 166.914 19.9714 163.348 19.9714",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 57.1704,
    width: 52.6678,
    height: 51.9037,
    rx: 16.5,
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_468_3264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.773 91.3172C217.162 91.02 216.615 90.6065 216.162 90.0997C215.679 89.5701 215.298 88.9563 215.037 88.2888",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.558 86.6519C211.558 85.4113 211.839 84.1869 212.382 83.0711C212.781 82.2475 219.743 71.8171 219.743 71.8171C219.743 71.8171 226.705 82.2475 227.104 83.0711C227.642 84.178 227.923 85.392 227.927 86.6228C227.931 87.8535 227.658 89.0693 227.127 90.1797C226.596 91.29 225.822 92.2664 224.861 93.0361C223.901 93.8057 222.779 94.3489 221.58 94.6252C220.381 94.9014 219.134 94.9036 217.934 94.6317C216.734 94.3597 215.61 93.8205 214.647 93.0543C213.684 92.288 212.906 91.3144 212.371 90.206C211.836 89.0975 211.558 87.8827 211.558 86.6519",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 52.6678,
    height: 51.9037,
    rx: 16.5,
    transform: "matrix(-1 0 0 1 119.668 57.6704)",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_468_3264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.112 71.4246H101.131",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9236 78.047L93.4895 76.5187L93.9989 74.4811L95.0177 73.9717",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4518 88.2354H79.7353V92.3107H91.4518V88.2354Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0554 84.1599H85.8483V88.2352H97.0554V84.1599Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8483 84.1599H79.7353V88.2352H85.8483V84.1599Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.168 88.2354H91.4518V92.3107H103.168V88.2354Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.168 71.4248C103.168 71.0903 103.102 70.7591 102.974 70.45C102.846 70.141 102.659 69.8602 102.422 69.6237C102.186 69.3872 101.905 69.1996 101.596 69.0716C101.287 68.9436 100.956 68.8777 100.621 68.8777C100.151 68.8783 99.6905 69.0107 99.2917 69.2597L94.5083 72.953L95.5271 74.9906C95.5271 74.9906 101.039 73.9362 101.192 73.9005C101.752 73.7716 102.253 73.4568 102.612 73.0073C102.971 72.5578 103.167 72 103.168 71.4248V71.4248Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2824 81.1036L90.433 73.4624L93.4895 81.1036H82.2824Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 8.17041,
    width: 52.6641,
    height: 51.9,
    rx: 16.5,
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_468_3264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5669 30.8095C24.5444 30.3352 24.6212 29.8615 24.7924 29.4187C24.9636 28.9759 25.2255 28.5738 25.5612 28.2381C25.8969 27.9024 26.299 27.6405 26.7418 27.4693C27.1846 27.2981 27.6583 27.2213 28.1325 27.2438C28.6068 27.2213 29.0805 27.2981 29.5233 27.4693C29.9661 27.6405 30.3682 27.9024 30.7039 28.2381C31.0396 28.5738 31.3015 28.9759 31.4727 29.4187C31.6439 29.8615 31.7207 30.3352 31.6982 30.8095",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1325 21.1313V25.2063",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5107 23.6782L24.5669 26.7345",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9638 30.3H23.0388",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7544 23.6782L31.6982 26.7345",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3013 30.3H33.2263",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8294 41.5063H17.4357L19.9825 32.8469H36.2825L38.8294 41.5063Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6794 32.8469L31.6982 41.5063",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5857 32.8469L24.5669 41.5063",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1325 45.072V41.5063",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2256 45.072H32.2076",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9638 36.9219H37.3013",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_3264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.4518,
    height: 23.433,
    fill: "white",
    transform: "translate(270.462 23.1887)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_468_3264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.4518,
    height: 24.4518,
    fill: "white",
    transform: "translate(145.518 15.8962)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_468_3264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3925,
    height: 24.4518,
    fill: "white",
    transform: "translate(211.047 70.8962)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_468_3264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.4518,
    height: 24.4518,
    fill: "white",
    transform: "translate(79.2259 68.3682)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_468_3264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.7538,
    height: 24.45,
    fill: "white",
    transform: "translate(16.7531 21.1313)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFuture1);
export default __webpack_public_path__ + "static/media/mobile-future1.8be4b68d57fb2c541594718b789032db.svg";
export { ForwardRef as ReactComponent };